import React from 'react';
import PropTypes from 'prop-types';
import './table.scss';

export const Table = ({ headers, data, aria }) => {
  const isKeyedTable = headers ? (headers[0].key ? true : false) : false;
  return (
    <div className="table-component">
      <table aria-label={aria}>
        <thead>
          <tr>
            {headers.map((header, h) => {
              return <th key={`header-${h}`}>{header.value || header}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data.map((row, r) => {
            return (
              <tr key={`row-${r}`}>
                {isKeyedTable
                  ? headers.map((header, h) => {
                      return <td key={`cell-${h}`}>{row[header.key]}</td>;
                    })
                  : row.map((cell, c) => {
                      return <td key={`cell-${c}`}>{cell.value || cell}</td>;
                    })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  headers: PropTypes.array,
  data: PropTypes.array,
  aria: PropTypes.string,
};
